<template>
  <div class="wide-frame">
    <section class="awaiting-payment-page">
      <HeaderWithIcon title="Payment" />
      <iframe :src="paymentUrl" v-if="!awaitingPaymentConfirmation"></iframe>
      <p v-else>
        You appear to have already attempted to pay. Please wait as this may
        take some time. If not, please contact us.
      </p>
    </section>
  </div>
</template>

<script>
import { useMemberDetails } from "@/helpers/member-details";
import HeaderWithIcon from "@/components/HeaderWithIcon";

export default {
  components: {
    HeaderWithIcon,
  },
  setup() {
    const { paymentUrl, awaitingPaymentConfirmation } = useMemberDetails();

    return {
      paymentUrl,
      awaitingPaymentConfirmation,
    };
  },
};
</script>

<style lang="scss" scoped>
iframe {
  background: var(--mid-grey);
  min-height: 50vh;
  width: 100%;
}
</style>
